import type { AuthenticatedClientUser } from '@src/authentication/AuthenticatedClientUser';
import type { AuthenticatedUser } from '@src/authentication/AuthenticatedUser';
import { createContext } from 'react';

interface AuthenticationContext {
  user: AuthenticatedUser | AuthenticatedClientUser | null;
  isLoading: boolean;
  logout: () => void;
}

export const AuthenticationContext = createContext<AuthenticationContext>({
  user: null,
  isLoading: false,
  logout: () => undefined,
});
